module.exports = __webpack_public_path__ + "static/media/ehsan_2.7dc4ce10.png";